import React from 'react';
import { Typography, Button, theme } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

import { CustomTooltip } from '~components/Tooltip';

function ClickableWrapper({ children, onClick }: React.PropsWithChildren<{ onClick?: () => void }>) {
  if (onClick) {
    return (
      <Button type="text" onClick={onClick} style={{ height: 'unset', padding: '0px 4px' }}>
        {children}
      </Button>
    );
  }
  return <>{children}</>;
}

type LegendLabelSquareProps = {
  color: string;
  label: string;
  small?: boolean;
  tooltipContent?: string;
  crossedOut?: boolean;
  onClick?: () => void;
};
function LegendLabelSquare({
  color,
  label = '',
  small = false,
  tooltipContent,
  crossedOut,
  onClick,
}: LegendLabelSquareProps) {
  const { token } = theme.useToken();

  return (
    <ClickableWrapper onClick={onClick}>
      <div style={{ whiteSpace: 'nowrap' }}>
        <div
          aria-label="legend-item-color-square"
          style={{
            display: 'inline-block',
            aspectRatio: 1,
            width: small ? 8 : 12,
            borderRadius: small ? 2 : 4,
            backgroundColor: color,
            marginRight: token.sizeXXS,
          }}
        ></div>
        <Typography.Text style={{ textDecoration: crossedOut ? 'line-through' : 'none' }}>{label}</Typography.Text>
        {tooltipContent && (
          <CustomTooltip message={tooltipContent} placement="top">
            <InfoCircleOutlined style={{ marginLeft: token.sizeXXS }} aria-label="legend-item-tooltip" />
          </CustomTooltip>
        )}
      </div>
    </ClickableWrapper>
  );
}

export default LegendLabelSquare;
